import React from 'react'
import HeaderStartupApproved from '../components/Header/HeaderStartupApproved/HeaderStartupApproved'
import { useState } from 'react'

const StartupApprovedLayout = ({ children, setIsFeePageActive }) => {
    const [isFeePageActive, setLocalIsFeePageActive] = useState(false)

    const setter = setIsFeePageActive || setLocalIsFeePageActive
    return (
        <div className='approved-layout'>
            <div className="sticky-top">
                <HeaderStartupApproved isFeePageActive={isFeePageActive} />
            </div>
            <div className='approved-main'>
                <div className="approved-content">{
                    React.cloneElement(children, {
                        isFeePageActive,
                        setIsFeePageActive: setter
                    })
                }</div>
            </div>
        </div>
    )
}

export default StartupApprovedLayout